import PropTypes from "prop-types";
import React from "react";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {DefaultButton, Image, ImageFit, Label, Stack} from "@fluentui/react";
import * as commonUtils from "../../utils/CommonUtils";
import * as authActions from "../../services/auth/auth-actions";
import * as safeActions from "../../services/safe/safe-actions";

const CvPhoto = prps => {

  const selectors = useSelector(
    state => ({
      authInfo: state.auth.authInfo,
      selectedAccountId: state.ui.selectedId.account,
      accountEntity: state.safe.content.account
    }),
    {equalityFn: shallowEqual}
  );
  const dispatch = useDispatch();
  const dispatches = React.useMemo(() => ({
      fetchProfilePhoto: id => dispatch(authActions.fetchProfilePhoto(id)),
      selectPhotoToUpload: instanceId => dispatch(safeActions.selectPhotoToUpload(instanceId))
    }),
    [dispatch]);
  const props = {...prps, ...selectors, ...dispatches};

  const {entity, instanceId, replaceInstance} = props.instanceContext;
  const instance = entity?.[instanceId];

  const isEditable = commonUtils.isEditAccountAllowed(instanceId, props.authInfo);

  const photoB64 = instance?.[props.field];

  const photoProps = {
    src: photoB64,
    alt: "Profielfoto",
    styles: prps => ({ root: { border: `1px solid ${prps.theme.palette.neutralSecondary}` } }),
    width: "10em",
    height: "10em",
    imageFit: ImageFit.contain
  };

  const onFetchProfilePhoto = () =>
    props.fetchProfilePhoto(instanceId);

  const onFileUpload = () =>
    props.selectPhotoToUpload(instanceId);

  const onDeletePhoto = () => {
    const instanceToBeSaved = {
      ...instance,
      [props.field]: null
    };
    replaceInstance?.(instanceId, instanceToBeSaved);
  };

  return (
    <Stack horizontal tokens={{ childrenGap: "l1" }}>
      <Label>{props.label}</Label>
      <Image {...photoProps}></Image>
      <Stack vertical verticalAlign="space-between" tokens={{ childrenGap: "l1" }}>
        <Stack vertical tokens={{ childrenGap: "l1" }}>
          <DefaultButton
            primary={true}
            text="Foto uploaden"
            iconProps={{ iconName: "Upload" }}
            disabled={!isEditable}
            onClick={onFileUpload}
          />
          <DefaultButton
            text="Cerios profielfoto"
            iconProps={{ iconName: "ProfileSearch" }}
            disabled={!isEditable || props.authInfo.accountId !== instanceId}
            onClick={onFetchProfilePhoto}
          />
        </Stack>
        <DefaultButton
          text="Foto verwijderen"
          iconProps={{ iconName: "Delete" }}
          disabled={!isEditable || !photoB64}
          onClick={onDeletePhoto}
        />
      </Stack>
    </Stack>
  );
};

CvPhoto.propTypes = {
  authInfo: PropTypes.object,
  instanceContext: PropTypes.object,
  field: PropTypes.string,
  label: PropTypes.any,
  fetchProfilePhoto: PropTypes.func,
  selectPhotoToUpload: PropTypes.func
};

export default CvPhoto;